import { atom } from 'jotai'
import { IJobsListQuery } from './CommunityJobs'

export const queryInitialState: IJobsListQuery = {
  page: 1,
  queries: [`?page=1&limit=30`],
  nextQuery: '',
  search: null,
  sortBy: 'createdAt:DESC',
  totalItems: 0,
  loadedItems: 0,
  filters: { positions: [], jobCategories: [] },
  scrollPosition: 0,
}

export const initialQueryStateAtom = atom<IJobsListQuery>(queryInitialState)
